import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CBadge } from '@coreui/react-pro';

import { resetGeneralState } from '../../../actions/general';
import { INITIAL_STATE } from '../../../reducers/general';

export const SidebarNav = ({ items }) => {
     const location = useLocation();
     const dispatch = useDispatch();
     const generalState = useSelector((state) => state.general);

     const navLink = (name, icon, badge) => {
          return (
               <>
                    {icon && icon}
                    {name && name}
                    {badge && (
                         <CBadge color={badge.color} className="ms-auto">
                              {badge.text}
                         </CBadge>
                    )}
               </>
          );
     };

     // const navItem = (item, index) => {
     //      const { component, name, badge, icon, ...rest } = item;
     //      const Component = component;

     //      return (
     //           <Component
     //                {...(rest.to &&
     //                     !rest.items && {
     //                          component: NavLink,
     //                          // activeClassName: 'active',
     //                     })}
     //                key={index}
     //                {...rest}
     //                onClick={handleClickNavItem}
     //           >
     //                {navLink(name, icon, badge)}
     //           </Component>
     //      );
     // };

     const navItem = (item, index) => {
          const { component, name, badge, icon, ...rest } = item;
          const Component = component;

          const RenderComponent = rest.to && !rest.items ? NavLink : Component;
          const isNavLink = rest.to && !rest.items;

          const navLinkProps = {
               ...rest,
               onClick: handleClickNavItem,
          };

          if (isNavLink) {
               navLinkProps.className = `nav-link${rest.className ? ` ${rest.className}` : ``}`;
          }

          return (
               <RenderComponent key={index} {...navLinkProps}>
                    {navLink(name, icon, badge)}
               </RenderComponent>
          );
     };

     const navGroup = (item, index) => {
          const { component, name, icon, to, ...rest } = item;
          const Component = component;

          return (
               <Component idx={String(index)} key={index} toggler={navLink(name, icon)} visible={location.pathname.startsWith(to)} {...rest}>
                    {item.items?.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
               </Component>
          );
     };

     const handleClickNavItem = () => {
          // Reset general state
          const generalStates = Object.entries(generalState);
          const generalStateLength = generalStates.length;

          if (!generalStateLength) {
               return;
          }

          let hasBeenChanged = false;

          for (let i = 0; i < generalStateLength; i++) {
               const [generalKey, generalValue] = generalStates[i];

               if (generalValue !== INITIAL_STATE[generalKey]) {
                    hasBeenChanged = true;
               }
          }

          if (hasBeenChanged) {
               dispatch(resetGeneralState());
          }
          // End reset general state
     };

     return <>{items && items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}</>;
};

SidebarNav.propTypes = {
     items: PropTypes.arrayOf(PropTypes.any).isRequired,
};
